import {
  connectedFinancialInstitutions,
  connectedFinancialInstitutionPromise
} from './financialaccount.state';
import { FinancialInstitution } from '@/modules/predefined/models/FinancialInstitution';

export function getConnectedFinancialInstitutions(): FinancialInstitution[] {
  return connectedFinancialInstitutions.value;
}

export function getConnectedPromise(): Promise<FinancialInstitution[]> | null {
  return connectedFinancialInstitutionPromise.value;
}
